export const getQueryString = (key: string) => {
  if (!window || key === '') {
    return
  }

  const params = new URLSearchParams(window.location.search)
  return params.get(key)
}
